<div class="flex flex-col gap-4 rounded-xl border border-solid border-primary-blue p-4 pb-6 shadow-card" [formGroup]="formGroup">
  <div class="flex items-center justify-between">
    <lib-input
      class="!w-[600px]"
      [formControl]="formGroup.controls.descriptionText"
      [placeholder]="'health_history_patient_alerts_tab_description' | translate"
      [maxLength]="DESCRIPTION_TEXT_MAX_LENGTH"
      [state]="validationErrors().description && saveClicked() ? 'error' : 'normal'"
      [hint]="validationErrors().description && saveClicked() ? ('patient_alert_description_error' | translate) : null"
    ></lib-input>
    @if (!isNewItem()) {
      <button
        class="btn-text-warn gap-[0.625rem] text-[0.875rem]"
        (click)="onDeleteClick()"
        [disabled]="isDeleteDisabled()"
        [libUiTooltip]="!deletePatientAlertEnabled() ? deleteDisabledTooltip : undefined"
        tooltipPosition="bottom"
      >
        <svg-icon [ngClass]="isDeleteDisabled() ? 'text-text-light' : 'text-states-red'" key="px-16-delete"></svg-icon>
        {{ 'health_history_health_history_tab_item_edit_delete' | translate }}
      </button>

      <ng-template #deleteDisabledTooltip>
        <div class="typo-h7-light max-w-[190px] whitespace-pre-wrap p-1">
          {{ 'patient_alerts_delete_disabled_tooltip' | translate }}
        </div>
      </ng-template>
    }
  </div>
  <div class="flex flex-col gap-1.5">
    <div class="flex items-center gap-2">
      <lib-health-history-date-picker
        labelTranslationKey="health_history_patient_alerts_tab_date_start"
        [formControl]="formGroup.controls.startDatePicker"
        [errorState]="validationErrors().dateRange && saveClicked() && !formGroup.controls.startDatePicker.value"
      ></lib-health-history-date-picker>
      <lib-health-history-date-picker
        labelTranslationKey="health_history_patient_alerts_tab_date_end"
        [formControl]="formGroup.controls.endDatePicker"
        [errorState]="validationErrors().dateRange && saveClicked() && !formGroup.controls.endDatePicker.value"
      ></lib-health-history-date-picker>
      @if (!isNewItem()) {
        <lib-health-history-date-picker
          labelTranslationKey="health_history_patient_alerts_tab_date_created"
          [formControl]="formGroup.controls.createdDatePicker"
        ></lib-health-history-date-picker>
      }
      <div class="flex items-center gap-2 pt-[18px]">
        <lib-checkbox
          [formControl]="formGroup.controls.alwaysOnCheckBox"
          [variant]="validationErrors().dateRange && saveClicked() ? 'error' : 'primary'"
        ></lib-checkbox>
        <span class="typo-h4-light font-light leading-none">{{ 'health_history_patient_alerts_tab_always_on' | translate }}</span>
      </div>
    </div>
    @if ((validationErrors().dateRange || validationErrors().startDateAfterEndDate) && saveClicked()) {
      <div class="typo-h7-light font-semibold text-states-red">
        {{
          (validationErrors().startDateAfterEndDate ? 'patient_alert_start_date_after_end_date_error' : 'patient_alert_date_range_error')
            | translate
        }}
      </div>
    }
  </div>
  <div class="flex flex-col gap-1.5 pl-2">
    <div class="typo-h5-book leading-none">{{ 'health_history_patient_alerts_tab_show_in' | translate }}</div>
    <div class="flex items-center gap-3">
      <div class="flex items-center gap-2">
        <lib-checkbox
          [formControl]="formGroup.controls.scheduleCheckBox"
          [variant]="validationErrors().showIn && saveClicked() ? 'error' : 'primary'"
        ></lib-checkbox>
        <span class="typo-h4-light font-light leading-none">{{ 'health_history_patient_alerts_tab_schedule' | translate }}</span>
      </div>
      <div class="flex items-center gap-2">
        <lib-checkbox
          [formControl]="formGroup.controls.patientChartCheckBox"
          [variant]="validationErrors().showIn && saveClicked() ? 'error' : 'primary'"
        ></lib-checkbox>
        <span class="typo-h4-light font-light leading-none">{{ 'health_history_patient_alerts_tab_patient_chart' | translate }}</span>
      </div>
    </div>
    @if (validationErrors().showIn && saveClicked()) {
      <div class="typo-h7-light font-semibold text-states-red">{{ 'patient_alert_show_in_error' | translate }}</div>
    }
  </div>
  <div class="flex flex-col gap-1.5">
    @if (editText()) {
      <lib-textarea-with-ai
        [formControl]="formGroup.controls.noteTextArea"
        [maxRows]="3"
        [isInputFocused]="true"
        [errorState]="validationErrors().note && saveClicked()"
        [closeButtonDisabled]="isVoiceTyping()"
        (voiceTypingStatusChange)="onVoiceTypingStatusChange($event)"
        (closeClicked)="closeTextarea()"
      ></lib-textarea-with-ai>
    } @else {
      @if (formGroup.controls.noteTextArea.value) {
        <lib-text-with-show-more
          class="typo-h4-light font-light leading-5 text-text-secondary"
          [text]="formGroup.controls.noteTextArea.value"
          [maxRows]="8"
          (textClick)="editText.set(true)"
        ></lib-text-with-show-more>
      } @else {
        <div
          class="flex items-center gap-2 rounded-2xl border border-solid p-3 leading-none text-text-light"
          (click)="editText.set(true)"
          [ngClass]="validationErrors().note && saveClicked() ? 'border-states-red' : 'border-text-extra-light'"
        >
          {{ 'health_history_note_placeholder' | translate }}
          <svg-icon class="max-h-4 max-w-4 text-text-light" key="px-16-voice-v-2"></svg-icon>
        </div>
      }
    }
    @if (validationErrors().note && saveClicked()) {
      <div class="typo-h7-light font-semibold text-states-red">{{ 'patient_alert_note_error' | translate }}</div>
    }
  </div>
  <div class="flex items-center justify-end gap-2">
    <button
      class="btn-secondary flex h-[32px] w-[100px] items-center gap-1"
      type="button"
      (click)="onCancelClick()"
      [disabled]="isLoading() || isVoiceTyping()"
    >
      <span class="typo-h5-semibold leading-none">{{ 'health_history_health_history_tab_item_edit_cancel' | translate }}</span>
    </button>
    <button
      class="btn-primary flex h-[32px] w-[100px] items-center gap-1"
      type="button"
      [disabled]="isLoading() || isVoiceTyping()"
      (click)="onSaveClick()"
    >
      @if (isLoading()) {
        <ng-lottie [options]="lottieOptions" currentColor class="mx-auto my-auto w-4"></ng-lottie>
      } @else {
        <svg-icon class="max-h-4 max-w-4 text-states-white" key="px-16-save"></svg-icon>
        <span class="typo-h5-semibold leading-none">{{ 'health_history_health_history_tab_item_edit_save' | translate }}</span>
      }
    </button>
  </div>
</div>
